export function isDateInFuture(dateContent: string) {
  const date = new Date(dateContent).getTime();
  const now = new Date().getTime();

  return date > now;
}
